/**
 * Alerts Tour
 * Configure how you receive bill updates
 */

import type { Tour } from '@/types/onboarding';

export const alertsTour: Tour = {
  id: 'alerts',
  name: 'Stay Informed',
  description: 'Configure how you receive bill updates',
  startRoute: '/account?tab=notifications',
  steps: [
    {
      element: '[data-tour="notification-prefs"]',
      popover: {
        title: 'Your notification settings',
        description: 'Control exactly what updates you receive for your tracked bills.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: '[data-tour="alert-status-change"]',
      popover: {
        title: 'Know when bills move',
        description:
          'Get notified when a bill passes committee, gets scheduled for a vote, or is signed into law.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="alert-title-change"]',
      popover: {
        title: 'Track bill substitutions',
        description:
          'Bills are sometimes replaced or renamed during the legislative process. Stay informed when this happens to bills you track.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="alert-new-bill"]',
      popover: {
        title: 'Discover new legislation',
        description:
          'Get alerts when new bills are introduced that match topics you care about. Never miss relevant legislation.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="digest-frequency"]',
      popover: {
        title: 'Choose your frequency',
        description:
          'Get instant alerts for time-sensitive tracking, or daily/weekly digests for a summary view.',
        side: 'top',
        align: 'start',
      },
    },
  ],
};
